import React, { Component } from "react";
import ContentLoader from "react-content-loader"

class TradeDocumentStatus extends Component {
  get document() {
    return this.props.tradeDocumentType === 'purchase_order' ? this.props.tradeDocument.purchase_order_document : this.props.tradeDocument.invoice_document;
  }

  stepTimer(step) {
    if(!this.props.tradeDocument) return;

    if(this.props.currentStep > step) return "Done";
    if(this.props.currentStep === 4 && step === 4) {
      if(this.props.tradeDocument.stage === 'for_final_assessment') {
        return "In Progress";
      } else {
        return "Done"
      }
    }
    if(this.isRejected() && this.props.currentStep === step) return "Rejected"
    if(this.props.currentStep === step) return "In Progress";
  }

  inQueueClassName() {
    if(!this.props.tradeDocument) return;

    if(this.props.currentStep === 1) {
      return `sequence-item -active ${this.isRejected()}`;
    } else if(this.props.currentStep > 1) {
      return `sequence-item -success`;
    }
  }

  verifyingDocClassName() {
    if(!this.props.tradeDocument) return;

    if(this.props.currentStep < 2) {
      return `sequence-item`;
    } else if (this.props.currentStep === 2) {
      return `sequence-item -active ${this.isRejected()}`;
    } else if(this.props.currentStep > 2) {
      return `sequence-item -success`;
    }
  }

  verifyingBuyerClassName() {
    if(!this.props.tradeDocument) return;

    if(this.props.currentStep < 3) {
      return `sequence-item`;
    } else if(this.props.currentStep === 3) {
      return `sequence-item -active ${this.isRejected()}`;
    } else if(this.props.currentStep > 3) {
      return `sequence-item -success`;
    }
  }

  approvedClassName() {
    if(!this.props.tradeDocument) return;

    if(this.document.status === 'rejected') {
      return `sequence-item`;
    } else if(this.props.currentStep < 4) {
      return 'sequence-item';
    } else if(this.props.tradeDocument.stage === 'for_final_assessment') {
      return 'sequence-item -active';
    } else if(this.props.currentStep === 4) {
      return 'sequence-item -success';
    }
  }

  isRejected() {
    if(!this.props.tradeDocument) return;
    if (this.document.status === 'rejected') return '-stop';
  }

  emptyState() {
    return (
      <div className="ds-card">
        <section className="cardTitle">Application Status</section>
        <section className="cardSection">
          <ContentLoader
            height={130}
            width={670}
            speed={2}
            primaryColor="#f3f3f3"
            secondaryColor="#b2c9e0"
          >
            <circle cx="8" cy="20" r="8" />
            <circle cx="8" cy="50" r="8" />
            <circle cx="8" cy="80" r="8" />
            <circle cx="8" cy="110" r="8" />
            <rect x="38" y="10" rx="0" ry="0" width="100" height="16" />
            <rect x="38" y="40" rx="0" ry="0" width="140" height="16" />
            <rect x="38" y="70" rx="0" ry="0" width="140" height="16" />
            <rect x="38" y="100" rx="0" ry="0" width="140" height="16" />
            <rect x="570" y="10" rx="0" ry="0" width="70" height="16" />
            <rect x="588" y="40" rx="0" ry="0" width="50" height="16" />
            <rect x="588" y="70" rx="0" ry="0" width="50" height="16" />
            <rect x="588" y="100" rx="0" ry="0" width="50" height="16" />
          </ContentLoader>
        </section>
      </div>
    )
  }

  render() {
    if(!this.props.tradeDocument) return this.emptyState();

    return (
      <div className="ds-card">
        <section className="cardTitle">Application Status</section>
        <section className="cardSection">
          <div className="ds-sequence">
            <ul>
              <li className={this.inQueueClassName()}>
                <span className="main">In queue</span>
                <span className="sub">{this.stepTimer(1)}</span>
              </li>
              <li className={this.verifyingDocClassName()}>
                <span className="main">Verifying the document</span>
                <span className="sub">{this.stepTimer(2)}</span>
              </li>
              <li className={this.verifyingBuyerClassName()}>
                <span className="main">Confirming with the buyer</span>
                <span className="sub">{this.stepTimer(3)}</span>
              </li>
              <li className={this.approvedClassName()}>
                <span className="main" data-testid="for-final-assessment-label">For final assessment</span>
                <span className="sub" data-testid="for-final-assessment-value">{this.stepTimer(4)}</span>
              </li>
            </ul>
          </div>
        </section>
      </div>
    )
  }
}

export default TradeDocumentStatus;



// WEBPACK FOOTER //
// ./src/features/trade_documents/components/TradeDocumentStatus.js